<template>
  <div ref="chart" style="width: 95%; height: 300px"></div>
</template>

<script>
import { GoogleCharts } from "google-charts";
// import firebase from "firebase";
// import db from "@/main.js";
// import { ref } from "vue";

export default {
  name: "LineChart",
  components: {
    // GoogleCharts,
  },
  props: {
    text: {
      type: String,
      default: "hello world",
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  mounted() {
    GoogleCharts.load(
      () => {
        const data = GoogleCharts.api.visualization.arrayToDataTable(this.data);

        const options = {
          curveType: "function",
          legend: "none",
          colors: ["#721cff", "#721cff"],
          series: {
            0: { areaOpacity: 0.3 }, // Fill under the first line
            1: { areaOpacity: 0 }, // No fill for the second
          },
          backgroundColor: { fill: "transparent" },
          vAxis: {
            viewWindow: {
              min: 0,
            },
            minorGridlines: {
              color: "transparent",
            },
            majorGridlines: {
              color: "#e0e0e0", // Major gridline color
            },
          },
          hAxis: {
            gridlines: {
              color: "transparent", // removes vertical lines
            },
          },
        };

        const chart = new GoogleCharts.api.visualization.AreaChart(
          this.$refs.chart
        );
        chart.draw(data, options);
      },
      { packages: ["corechart"] }
    );
  },
  methods: {},
  setup() {
    return {};
  },
  data() {
    return {};
  },
};
</script>

<style></style>
